import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconTrackLocation = ({ t, fill, className, height, width }) => (
  <svg className={className} width={width} height={height}>
    <title>{t('Track Location')}</title>
    <path
      fill={fill}
      fillRule='evenodd'
      d='M18 .654c-.013-.065-.02-.132-.04-.195-.139-.427-.542-.573-1.016-.366C13.118 1.763 2.157 6.553.5 7.273c-.207.09-.375.208-.455.427-.148.404.076.765.567.909 2.202.643 4.404 1.288 6.607 1.926.136.04.2.105.24.24.64 2.213 1.285 4.424 1.93 6.635.109.372.327.57.64.59.295.018.535-.156.686-.502.202-.461 4.48-10.274 7.174-16.46.053-.121.117-.242.11-.384'
    />
  </svg>
)

export default Icon(IconTrackLocation)
